import { bindable, customElement, autoinject } from 'aurelia-framework';
import { CustomersCache } from '../../../services/customers-cache';
import { MdcTextField } from '@aurelia-mdc-web/text-field';
import { MyCustomerViewModel } from '@dynamik/common/clients/policy-clients';

@autoinject
@customElement('main-customer-lookup')
export class CompanyLookup {
  constructor(private element: Element, private customersCache: CustomersCache) { }

  customers: MyCustomerViewModel[];
  inputVm: MdcTextField;

  @bindable()
  value: MyCustomerViewModel;

  @bindable()
  placeholder: string;

  @bindable()
  hideHeader: boolean;

  getOptions = async (filter: string, value: MyCustomerViewModel): Promise<MyCustomerViewModel[]> => {
    this.customers = (await this.customersCache.get()).slice().sort((a, b) => a.name.localeCompare(b.name));
    if (value) {
      return Promise.resolve([value, ...this.customers.filter(x => x.companyId !== value.companyId)]);
    } else {
      return Promise.resolve(this.customers.filter(x => x.name.toUpperCase().includes((filter || '').toUpperCase())));
    }
  };

  gotoSettings() {
    this.element.dispatchEvent(new CustomEvent('goto-settings', { bubbles: true }));
  }

  handleFocus() {
    this.inputVm.input_.select();
  }

}
